import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    titleContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    successTitle: {
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.grey900,
        fontSize: theme.fontSize.xl
    },
    successSubTitle: {
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey900,
        fontSize: theme.fontSize.lg
    },
    checkIcon: {
        marginRight: '1rem',
        color: theme.colors.primary500
    }
}));

const CallBackSuccess = ({ name, providerName }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classNames('test-callBackForm-success')}>
            <div className={classes.titleContainer}>
                <FontAwesomeIcon className={classes.checkIcon} icon={faCheck} size="lg" />
                <Typography className={classes.successTitle}>{`Thanks ${name}`}</Typography>
            </div>
            <Typography className={classes.successSubTitle}>{`A ${providerName} specialist will be in touch with you shortly.`}</Typography>
        </div>
    );
};

CallBackSuccess.propTypes = {
    name: PropTypes.string.isRequired,
    providerName: PropTypes.string.isRequired
};

export { CallBackSuccess };
